module.exports = __webpack_public_path__ + "assets/img/support.1f9a7a3d.svg";